import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../../lib/axios';
import { CREATE_ADVERTISE } from '../../../lib/endpoints/advertise';
import moment from 'moment';
import { createNotificationService } from '../../../services/notification';
import { getDateTimeFromRef } from '../../../utils/dateTimeFormat';

interface Props {
  onClose: Function;
  onFetchData: Function;
}

const useFormNotificationController = ({ onClose, onFetchData }: Props) => {
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [selectedStartDateHour, setSelectedStartDateHour] = useState<string>('');

  const title = useRef<HTMLInputElement>();
  const description = useRef<HTMLInputElement>();
  const startDate = useRef<HTMLInputElement>(null!);

  const { t } = useTranslation('global');

  const handleOpenConfirmForm = (e: any) => {
    e.preventDefault();
    setOpenConfirm(true);
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  const handleSubmit = () => {
    handleCreateNotification();
  };

  const handleCreateNotification = async () => {
    try {
      setLoadingButton(true);
      const inputForm = {
        title: title.current?.value,
        message: description.current?.value,
        description: description.current?.value,
        startDate: getDateTimeFromRef(startDate, selectedStartDateHour),
      };
      await createNotificationService(inputForm);
      await onFetchData();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingButton(false);
      setOpenConfirm(false);
    }
  };

  return {
    handleOpenConfirmForm,
    handleCloseConfirmForm,
    handleSubmit,
    title,
    description,
    errorMessage,
    openConfirm,
    loadingButton,
    startDate,
    handleSelectedStartDateHour: (event: React.ChangeEvent<HTMLInputElement>) =>
      setSelectedStartDateHour(event.target.value),
    selectedStartDateHour,
  };
};
export default useFormNotificationController;
